export default __webpack_public_path__ + "static/media/view-item.836e22e4.png";